// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.CompanyOfficial_header__1ZFye {\n  margin-bottom: 28px; }\n", ""]);
// Exports
exports.locals = {
	"header": "CompanyOfficial_header__1ZFye"
};
module.exports = exports;
